import { getLogger } from "@expert/logging";

import { env } from "@/config";
import { getSharedApiClient } from "@/shared-utils";

const contextLogger = getLogger({ module: "accessTokenGenerator" });

interface TwilioTokenResponse {
    accessToken: string;
}

export async function getServiceProviderAccessToken(userFriendlyName?: string): Promise<string> {
    try {
        const { accessToken } = await getSharedApiClient()
            .post(env.accessTokenGeneratorPath, { json: { userFriendlyName } })
            .json<TwilioTokenResponse>();
        return accessToken;
    } catch (error: unknown) {
        contextLogger.fatal({ error }, "Failed to fetch service provider access token");
        throw error;
    }
}
